import { cellValueFromGQL, isNoneCell } from "Backend";
import { CellType, CellValue } from "generated/graphql";
import { stripNull } from "helpers/coll";

export function compareCellValues(a: CellValue | undefined, b: CellValue | undefined, sortDir: "asc" | "desc"): number {
  if (a === undefined && b === undefined) return 0;
  if (a === undefined) return sortDir === "asc" ? 1 : -1;
  if (b === undefined) return sortDir === "asc" ? -1 : 1;
  const dateA = stripNull(a.dateValue);
  const dateB = stripNull(b.dateValue);
  const numberA = stripNull(a.integerValue ?? a.floatValue);
  const numberB = stripNull(b.integerValue ?? b.floatValue);
  const simpleA = cellValueFromGQL(a);
  const simpleB = cellValueFromGQL(b);

  if (simpleA === undefined && simpleB === undefined) return 0;
  // Push all empty cells to the bottom, regardless of sort order
  if (simpleA === undefined) return 1;
  if (simpleB === undefined) return -1;

  const aIsNone = isNoneCell(a);
  const bIsNone = isNoneCell(b);

  if (aIsNone && bIsNone) return 0;
  // Push all empty cells to the bottom, regardless of sort order
  if (aIsNone) return 1;
  if (bIsNone) return -1;

  if (dateA !== undefined && dateB !== undefined) {
    return sortDir === "asc" ? dateA.localeCompare(dateB) : dateB.localeCompare(dateA);
  } else if (a.type === CellType.Boolean) {
    if (simpleA === simpleB) return 0;
    return sortDir === "asc" ? (simpleA ? -1 : 1) : simpleA ? 1 : -1;
  } else if (numberA !== undefined && numberB !== undefined) {
    return sortDir === "asc" ? numberA - numberB : numberB - numberA;
  } else if (a.type === CellType.Text || a.type === CellType.Select) {
    return sortDir === "asc"
      ? (simpleA as string).localeCompare(simpleB as string)
      : (simpleB as string).localeCompare(simpleA as string);
  } else {
    // We don't really sort multi-select values
    return 0;
  }
}
